import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Modal } from 'react-native';
import { UserServices } from '../../../../database/user.database';
import { FlashList } from '@shopify/flash-list';
import { ScrollView, TextInput } from 'react-native-gesture-handler';

const TableViewerScreen = () => {
    const [tables, setTables] = useState([]); // Para guardar la lista de tablas
    const [tableData, setTableData] = useState([]); // Para guardar los datos de la tabla seleccionada
    const [selectedTable, setSelectedTable] = useState(null); // Tabla actualmente seleccionada
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [allColumns, setAllColumns] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [totalReg, setTotalReg] = useState(0);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState(null);
    useEffect(() => {
        const fetchTables = async () => {
            let tables = await UserServices.getTableNames();
            // Ordenar las tablas en orden alfabético
            tables.sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }));

            setTables(tables);
        };

        fetchTables();
    }, []);

    // Obtener los datos de una tabla seleccionada
    const fetchTableData = async (tableName, page = 1, pageSize = 10, clear = false) => {
        let get_table = await UserServices.getTableData(tableName, page, pageSize, !clear ? searchTerm : null);
        //console.log("🚀 ~ fetchTableData ~ get_table:", get_table)
        if (page == 1) {
            let count_reg = await UserServices.getCountTableData(tableName, !clear ? searchTerm : null);
            setTotalReg(count_reg)
        }
        setTableData(get_table);
        setSelectedTable(tableName);

        if (get_table.length > 0) {
            const columns = Object.keys(get_table[0]);
            if (page == 1) {
                setAllColumns(columns);
                setSelectedColumns(columns); // Inicializa con todas las columnas
            }
        }
    };
    const clearSearch = async (tableName, page = 1, pageSize = 10) => {
        try {
            setSearchTerm(null);
        } catch (error) {
            console.error("~ clearSearch ~ error:", error)

        } finally {
            fetchTableData(tableName, page, pageSize, true)
        }


    };
    const goToNextPage = () => {
        setCurrentPage((prevPage) => prevPage + 1);
        fetchTableData(selectedTable, currentPage + 1, pageSize);
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prevPage) => prevPage - 1);
            fetchTableData(selectedTable, currentPage - 1, pageSize);
        }
    };

    const renderColumnSelector = () => {
        return (
            <View style={styles.columnSelectorContainer}>
                {allColumns.map((column, index) => (
                    <TouchableOpacity
                        key={index}
                        onPress={() => toggleColumnSelection(column)}
                        style={{
                            backgroundColor: selectedColumns.includes(column) ? '#6c757d' : '#f0f0f0',
                            paddingVertical: 5,
                            paddingHorizontal: 5,
                            margin: 5,
                            borderRadius: 10,
                            borderWidth: 0.5,
                            borderColor: '#ccc',
                        }}
                    >
                        <Text
                            style={{
                                color: selectedColumns.includes(column) ? '#fff' : '#000',
                                fontSize: 10,
                                fontWeight: '500',
                            }}
                        >
                            {column}
                        </Text>
                    </TouchableOpacity>
                ))}
            </View>
        );
    };



    const toggleColumnSelection = (column) => {
        setSelectedColumns(prev =>
            prev.includes(column) ? prev.filter(col => col !== column) : [...prev, column]
        );
    };

    const renderTableDataItem0 = ({ item }) => {
        const truncateValue = (value) => {
            if (typeof value === 'string' && value.length > 24) {
                return value.substring(0, 90) + '...';
            }
            return value;
        };

        return (
            <View style={styles.tableRow}>
                <ScrollView horizontal={true} style={styles.scrollRow}>
                    {selectedColumns.map((key, index) => (
                        <View key={index} style={styles.tableCell}>
                            <Text style={styles.cellLabel}>{key}:</Text>
                            <Text style={styles.cellValue}>
                                {typeof item[key] === 'object' ? JSON.stringify(item[key]) : truncateValue(item[key])}
                            </Text>
                        </View>
                    ))}
                </ScrollView>
            </View>
        );
    };
    const renderTableDataItem = ({ item }) => {
        const truncateValue = (value) => {
            if (typeof value === 'string' && value.length > 24) {
                return value.substring(0, 90) + '...';
            }
            return value;
        };

        return (
            <TouchableOpacity
                onPress={() => {
                    setSelectedItem(item);
                    setIsModalVisible(true);
                }}
                style={styles.tableRow}>
                <ScrollView
                    horizontal={true}
                    showsHorizontalScrollIndicator={true}
                    style={styles.scrollRow}
                    contentContainerStyle={styles.scrollContent}
                >
                    {selectedColumns.map((key, index) => (
                        <View key={index} style={styles.tableCell}>
                            <Text style={styles.cellLabel}>{key}:</Text>
                            <Text style={styles.cellValue}>
                                {typeof item[key] === 'object' ? JSON.stringify(item[key]) : truncateValue(item[key])}
                            </Text>
                        </View>
                    ))}
                </ScrollView>

                {/* <ScrollView horizontal={true} style={styles.scrollRow}>
                    {selectedColumns.map((key, index) => (
                        <View key={index} style={styles.tableCell}>
                            <Text style={styles.cellLabel}>{key}:</Text>
                            <Text style={styles.cellValue}>
                                {typeof item[key] === 'object' ? JSON.stringify(item[key]) : truncateValue(item[key])}
                            </Text>
                        </View>
                    ))}
                </ScrollView> */}
            </TouchableOpacity>
        );
    };
    const renderModal = () => {
        if (!selectedItem) return null;

        return (
            <Modal
                visible={isModalVisible}
                transparent={true}
                animationType="slide"
                onRequestClose={() => setIsModalVisible(false)}>
                <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>
                        <Text style={styles.modalTitle}>Detalles del Item</Text>
                        <ScrollView>
                            {Object.keys(selectedItem).map((key, index) => (
                                <View key={index} style={styles.modalRow}>
                                    <Text style={styles.modalKey}>{key}:</Text>
                                    <Text style={styles.modalValue}>
                                        {typeof selectedItem[key] === 'object' ? JSON.stringify(selectedItem[key]) : selectedItem[key]}
                                    </Text>
                                </View>
                            ))}
                        </ScrollView>
                        <TouchableOpacity
                            style={styles.closeButton}
                            onPress={() => setIsModalVisible(false)}>
                            <Text style={styles.closeButtonText}>Cerrar</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </Modal>
        );
    };

    const totalPages = Math.ceil(totalReg / pageSize);

    const renderTableItem = ({ item }) => (
        <View style={styles.tableItem}>
            <TouchableOpacity
                onPress={() => fetchTableData(item)}
                style={styles.button}
                activeOpacity={0.6}>
                <Text style={styles.buttonText}>{item} </Text>
            </TouchableOpacity>
        </View>
    );
    return (
        <View style={styles.container}>
            <Text style={styles.title}>DB</Text>
            {selectedTable == null && (
                <FlashList
                    data={tables}
                    renderItem={renderTableItem}
                    keyExtractor={(item) => item}
                    estimatedItemSize={30}
                    numColumns={1}

                />
            )}

            {selectedTable && (
                <View style={styles.tableDataContainer}>

                    <Text style={styles.subtitle}>Tabla: {selectedTable.toUpperCase()},</Text>
                    <Text >count: {totalReg}, size:{pageSize}, maxpage: {totalPages}</Text>
                    <TouchableOpacity onPress={() => setSelectedTable(null)} style={styles.backButton}>
                        <Text style={styles.backButtonText}>Volver</Text>
                    </TouchableOpacity>
                    {renderColumnSelector()}
                    <View style={styles.searchContainer}>
                        <TextInput
                            placeholder="key, operador, valor"
                            value={searchTerm}
                            onChangeText={setSearchTerm}
                            style={styles.searchInput}
                            autoCapitalize="none"
                        />
                        <TouchableOpacity onPress={() => fetchTableData(selectedTable, 1, pageSize)} style={styles.searchButton}>
                            <Text style={styles.searchButtonText}>Buscar</Text>
                        </TouchableOpacity>
                        <TouchableOpacity onPress={() => clearSearch(selectedTable, 1, pageSize)} style={styles.searchButton}>
                            <Text style={styles.searchButtonText}>Limpiar</Text>
                        </TouchableOpacity>
                    </View>
                    {totalPages > 0 &&
                        <View style={styles.paginationContainer}>
                            <TouchableOpacity
                                onPress={() => goToPreviousPage()}
                                style={[
                                    styles.paginationButton,
                                    currentPage === 1 && styles.disabledButton // Deshabilita si estás en la primera página
                                ]}
                                disabled={currentPage === 1}
                            >
                                <Text style={styles.paginationText}>Anterior</Text>
                            </TouchableOpacity>

                            <Text style={styles.paginationInfo}>
                                Página {currentPage}
                            </Text>

                            <TouchableOpacity
                                onPress={() => goToNextPage()}
                                style={[
                                    styles.paginationButton,
                                    currentPage === totalPages && styles.disabledButton // Deshabilita si estás en la última página
                                ]}
                                disabled={currentPage === totalPages} // Desactivar cuando se esté en la última página
                            >
                                <Text style={styles.paginationText}>Siguiente</Text>
                            </TouchableOpacity>
                        </View>}


                    <ScrollView contentContainerStyle={{ flexGrow: 1 }}>
                        <ScrollView
                            horizontal={true}
                            contentContainerStyle={styles.scrollViewContent}
                        >
                            <View style={styles.tableDataWrapper}>
                                {tableData.map((item, index) => (
                                    <View key={index} style={styles.tableRow}>
                                        {renderTableDataItem({ item })}
                                    </View>
                                ))}
                            </View>
                        </ScrollView>
                    </ScrollView>
                </View>
            )}
            {renderModal()}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        padding: 10,
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    tableItem: {
        marginVertical: 6,
        // flexDirection: "row",
        flex: 1,
        flexWrap: 'wrap'
    },
    tableDataContainer: {
        marginTop: 10,
        padding: 10,
        borderTopWidth: 1,
        borderColor: '#ccc',
        flex: 1,
    },
    subtitle: {
        fontSize: 16,
        fontWeight: '600',
        marginBottom: 10,
    },
    tableRow: {
        marginBottom: 10,
        borderBottomWidth: 1,
        borderBottomColor: '#ddd',
        paddingVertical: 2,
    },
    scrollContent: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    scrollRow: {
        flexDirection: 'row',
        paddingHorizontal: 10,
        paddingVertical: 5,
    },
    tableCell: {
        paddingHorizontal: 10,
        marginBottom: 5,
        flexDirection: 'column',
    },
    cellLabel: {
        fontWeight: 'bold',
        fontSize: 10,
    },
    cellValue: {
        fontSize: 12,
        maxWidth: 180,
        overflow: 'hidden',
        // textOverflow: 'ellipsis',
        //whiteSpace: 'nowrap', // Esto asegura que el texto no se ajuste a múltiples líneas
    },
    button: {
        width: '100%',
        backgroundColor: '#6c757d',
        paddingVertical: 5,
        paddingHorizontal: 20,
        borderRadius: 5,
        alignItems: 'flex-start',
        //marginVertical: 1,
    },
    buttonText: {
        color: '#fff',
        fontSize: 12,
        fontWeight: '600',
        textTransform: 'uppercase',
    },
    backButton: {
        marginVertical: 10,
        paddingVertical: 10,
        backgroundColor: '#6c757d',
        borderRadius: 5,
        alignItems: 'center',
    },
    backButtonText: {
        color: '#fff',
        fontSize: 16,
        fontWeight: '600',
    },
    columnSelectorContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
    },
    scrollViewContent: {
        paddingBottom: 20,
    },
    tableDataWrapper: {
        flex: 1,
    },
    paginationContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: 10,
    },
    paginationButton: {
        padding: 5,
        backgroundColor: '#007BFF',
        borderRadius: 5,
    },
    disabledButton: {
        backgroundColor: '#CCC',
    },
    paginationText: {
        color: '#FFF',
        fontSize: 16,
    },
    paginationInfo: {
        fontSize: 16,
        fontWeight: 'bold',
    },
    modalContainer: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalContent: {
        width: '90%',
        height: '90%',
        backgroundColor: '#fff',
        borderRadius: 10,
        padding: 20,
        shadowColor: '#000',
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
    },
    modalTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 10,
    },
    modalRow: {
        marginVertical: 5,
    },
    modalKey: {
        fontWeight: 'bold',
    },
    modalValue: {
        fontSize: 14,
    },
    closeButton: {
        marginTop: 20,
        backgroundColor: '#6c757d',
        padding: 10,
        borderRadius: 5,
        alignItems: 'center',
    },
    closeButtonText: {
        color: '#fff',
        fontSize: 16,
    },
    searchContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginVertical: 10,
    },
    searchInput: {
        flex: 1,
        padding: 10,
        borderWidth: 1,
        borderColor: '#ccc',
        borderRadius: 5,
    },
    searchButton: {
        marginLeft: 10,
        paddingVertical: 10,
        paddingHorizontal: 15,
        backgroundColor: '#007bff',
        borderRadius: 5,
    },
    searchButtonText: {
        color: 'white',
        fontWeight: 'bold',
    },
});


export default TableViewerScreen;
